Date.prototype.addDays = function (days: number) {
  const date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}


export default class Shop {

  // -----------------------------------
  // Instance
  // -----------------------------------

  private static _instance: Shop;

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }


  // -----------------------------------
  // Instance
  // -----------------------------------

  public checkoutDrawer = false;


  public nextWorkingDay(): Date {
    let date = new Date();
    date = date.addDays(1);

    let acc = 0;

    while ((this._isWeekend(date) || this._isHoliday(date)) && acc < 50) {
      date = date.addDays(1);

      acc++;
    }

    return date
  }

  // -----------------------------------
  // Festive days
  // -----------------------------------


  // Hora de tall: la comanda feta abans de les 11 h d'un dia laborable surt aquell dia (com diu el compte enrere)
  public static CUTOFF_HOUR = 11;

  /** Dia en què surt la comanda feta ara: avui si és laborable i abans de l'hora de tall, si no el pròxim dia laborable. */
  public shipDate(): Date {
    const now = new Date();
    if (this._isWeekend(now) || this._isHoliday(now) || now.getHours() >= Shop.CUTOFF_HOUR) {
      return this.nextWorkingDay();
    }
    return now
  }

  /**
   * Dia en què arriba un enviament de `daysOfShipping` dies laborables (estàndard 1-3, Express 1-2), comptats des del
   * dia en què surt la comanda (shipDate): així una comanda de cap de setmana o festiu no guanya un dia.
   */
  public arrivesAtDate(daysOfShipping): Date {
    let arrivalDate = this.shipDate();
    let acc = 0;
    while (acc < daysOfShipping) {
      arrivalDate = arrivalDate.addDays(1);
      if (!this._isWeekend(arrivalDate) && !this._isHoliday(arrivalDate))
        acc++;
    }
    return arrivalDate
  }

  public arrivesAt(daysOfShipping, locale = 'ca-ES'): String {
    return this.arrivesAtDate(daysOfShipping).toLocaleDateString(locale, {weekday: 'long', day: 'numeric', month: 'long'})
  }

  /** Quan acaba el termini perquè la comanda surti el primer dia laborable: avui a les 11 h o el pròxim dia laborable. */
  public shipDeadline(): Date {
    const date = this.shipDate();
    date.setHours(Shop.CUTOFF_HOUR, 0, 0, 0);
    return date
  }

  private _isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6
  }

  private _isHoliday(date) {
    // console.log("this._cataloniaFestiveDays", this._cataloniaFestiveDays)
    // console.log("this._aragonFestiveDays", this._aragonFestiveDays)
    // console.log("this._spainFestiveDays", this._spainFestiveDays)
    const dateKey = date.getDate() + "/" + (date.getMonth() + 1)
    return this._spainFestiveDays.includes(dateKey) || this._cataloniaFestiveDays.includes(dateKey) || this._aragonFestiveDays.includes(dateKey)
  }

  private _spainFestiveDays = [
    "1/1", // Any nou
    "6/1", // Reis
    this._viernesSanto(),
    this._dillunsDePasqua(),
    "1/5", // Dia del treball
    "15/8", // l’Assumpció / Sant Maria
    "12/10", // Festa Nacional d'Espanya
    "1/11", // Tot Sants
    "6/12", // Dia de la Constitució
    "8/12", // La Immaculada
    "25/12", // Nadal
  ]

  private _aragonFestiveDays = [
    this._juevesSanto(), // Jueves santo
    "23/4" // Sant Jordi,
  ]

  private _cataloniaFestiveDays = [
    this._dillunsDePasqua(),
    this._pasquaGranada(),
    "24/6", // Sant Joan
    "11/9", // Diada Nacional de Catalunya
    "26/12", // Sant Esteve
  ]


  private _firstMonday() {
    return this._nextMonday(1, 1)
  }

  private _nextMonday(startingDay, month) {


    const actualYear = new Date().getFullYear();
    const dayOne = new Date(actualYear, month - 1, startingDay);
    let isMonday = false, fistMonday = null, i = 0;
    while (!isMonday && i < 7) {
      const day = dayOne.addDays(i);

      // Monday == 1
      if (day.getDay() === 1) {
        isMonday = true;
        fistMonday = day;
      }

      i++;
    }

    return fistMonday.getDate() + "/" + month
  }


  private _diumengeDePasqua() {
    const Y = new Date().getFullYear();
    let C = Math.floor(Y / 100);
    let N = Y - 19 * Math.floor(Y / 19);
    let K = Math.floor((C - 17) / 25);
    let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
    I = I - 30 * Math.floor((I / 30));
    I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
    let J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
    J = J - 7 * Math.floor(J / 7);
    let L = I - J;
    let M = 3 + Math.floor((L + 40) / 44);
    let D = L + 28 - 31 * Math.floor(M / 4);

    // M és el mes començant per 1 (3 = març, 4 = abril) i Date el vol començant per 0
    return new Date(Y, M - 1, D);
  }

  /** Clau "dia/mes" (com a les llistes de festius) del dia a `offset` dies del diumenge de Pasqua */
  private _pasquaMes(offset) {
    const d = this._diumengeDePasqua().addDays(offset)
    return d.getDate() + "/" + (d.getMonth() + 1)
  }

  private _juevesSanto() {
    return this._pasquaMes(-3)
  }

  private _viernesSanto() {
    return this._pasquaMes(-2)
  }

  private _dillunsDePasqua() {
    return this._pasquaMes(1)
  }

  private _pasquaGranada() {
    return this._pasquaMes(50)
  }

  private _sanJorge() {
    return this._nextMonday(23, 4)
  }

}
